<div class="wrapper">
  <div class="">
    <div class="mt-2">
      <div class="search-bar Custom-Search mx-auto mt-3">
        <button type="submit" class="msicon">
          <span class="material-symbols-outlined">search</span></button>
        <input type="search" class="form-control" [formControl]="searchControl" [(ngModel)]="searchText"
          placeholder="Search by Program"(keydown.enter)="onSearchTextChanged($event.target.value)"(keyup)="clearSearch()" >
        <button type="submit" class="msicon" (click)="clearSearchText()" *ngIf="searchText!=''"><span
            class="material-symbols-outlined"> close
          </span></button>
      </div>
    </div>

    <div class="main-text">
      <span class="h2 line_height_36" >Programs to get you started</span>
      <div *ngIf="isAssignedPrograms" class="d-flex">
        <mat-form-field class="custom_select mr-2">
          <mat-select [(ngModel)]="subGroup" (selectionChange)="filterProgramsByStatus()">
            <mat-option value="">All Categories</mat-option>
            <mat-option [value]="data" *ngFor="let data of filterSubGroup">{{data}}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="custom_select">
          <mat-select (selectionChange)="onYearChange()" [(ngModel)]="year">
            <mat-option [value]="data" *ngFor="let data of yearData">{{data}}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="custom_select mr-2" [ngClass]="{'disabled-dropdown': isQuarterDisabled}">
          <mat-select (selectionChange)="onQuarterChange()" [(ngModel)]="quarterNo" [disabled]="isQuarterDisabled"> 
            <mat-option [value]="data.id" *ngFor="let data of quarterData">{{data.name}}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="custom_select mr-2">
          <mat-select [(ngModel)]="statusId" (selectionChange)="filterProgramsByStatus()">
            <mat-option [value]="data.id" *ngFor="let data of filterProgram">{{data.name}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div *ngIf="isTrending" class="d-flex">
        <mat-form-field class="custom_select mr-2">
          <mat-select [(ngModel)]="practiceId" (selectionChange)="onPracticeChange()">
            <mat-option [value]="0">Select</mat-option>            <mat-option *ngFor="let practice of filteredPractices" [value]="practice.practiceID">
                {{practice.practiceName}}
          </mat-option></mat-select>
        </mat-form-field>
      </div>

    </div>
    <mat-tab-group [(selectedIndex)]="selectedTab" (selectedTabChange)="onTabChanged($event)">
      <mat-tab>
        <ng-template mat-tab-label>
          <span>Assigned to me{{ searchText && (assignCount
            > 0) ? '(' + assignCount + ')' : ''}}</span>
        </ng-template>
        <div class="tab_container">
          <div class="tab-background">
            <div class="card_body" *ngFor="let card of assignedProgarms; index as i">
              <div class="card" (click)="goToProgramDetails(card)">
                <div class="card-image">
                  <img [src]="card.programImage?card.programImage : '../../../../assets/images/employeeCareer/code.jpg'"
                    alt="Program Image" crossorigin="anonymous">
                  <span class="inprogress" *ngIf="card.status == 'In Progress' ">In Progress</span>
                  <span class="completed" *ngIf="card.status == 'Completed' ">Completed</span>
                  <span class="notstarted" *ngIf="card.status == 'Not Started' ">Not Started</span>
                </div>
                <div class="card-content">
                  <div class="card_head_content">
                    <div class="department textalign">
                      <span class="department-name ">{{card.departmentPathName || card?.subGroup}}</span>
                    </div>
                    <div class="card-title textalign" matTooltip="{{card.programName}}">{{card.programName}}</div>
                  </div>
                  <div class="counts">
                    <div class="col-md-6 pl-0">
                      <i class="fa fa-line-chart"></i>
                      <span class="pl-2">{{card?.complexityLevel}}</span><br>
                      <i class="fa fa-caret-square-o-right"></i>
                      <span class="pl-2">{{card?.totalCourses}} Courses</span>
                    </div>
                    <vr class="vertical"></vr>
                    <div class="col-md-6 pr-0">
                      <i class="fa fa-clock-o"></i>
                      <span class="pl-2">{{card?.totalTopicsLength}} total hours</span><br>
                      <i class="fa fa-list-alt"></i>
                      <span class="pl-2">{{card?.totalTopics}} Topics</span>
                    </div>
                  </div>
                </div>
              </div>
              <ng-container *ngIf="(i + 1) % 4 == 0 || i == assignedProgarms.length - 1">
                <div class="row"></div>
              </ng-container>
            </div>
          </div>
          <div class="view-more pt-2" *ngIf="assignedProgarms?.length >= 8 && showAssignedViewMore">
            <span (click)="loadAssignedPrograms()">View More</span>
          </div>
          <div class="view-more h-100" *ngIf="assignedProgarms?.length <= 0 && !loading">
            <div class="noDataCard align-items-center mt-0">
              <div class="noDataCardIn">
                <img src="../../../assets/images/no_data.png" height="120px"><br>
                <span class="mt-3 d-block"> No Programs Found</span>
              </div>
            </div>
          </div>
        </div>
      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          <span>Recommended{{ showRecommendedCount && searchText && (recommendedCount > 0) ? '(' + recommendedCount + ')' : ''}}</span>
        </ng-template>
        <div class="tab_container">
          <div class="tab-background">
            <div class="card_body" *ngFor="let card of recommendedPrograms; index as i">
              <div class="card" (click)="goToProgramDetails(card)">
                <div class="card-image">
                  <img [src]="card.url ?card.url: '../../../../assets/images/employeeCareer/code.jpg'"
                    alt="Program Image" crossorigin="anonymous">
                  <div class="text-overlay">
                    <span class="inprogress" *ngIf="card.status == 'InProgress' ">In Progress</span>
                    <span class="completed" *ngIf="card.status == 'Completed' ">Completed</span>
                    <span class="notstarted" *ngIf="card.status == 'Not Started' ">Not Started</span>
                  </div>
                </div>
                <div class="card-content">
                  <div class="card_head_content">
                    <div class="department textalign">
                      <span class="department-name " style="text-align: left;">{{card.departmentPathName}}</span>
                    </div>
                    <div class="card-title textalign" title="{{card.programName}}" matTooltip="{{card.programName}}">
                      {{card.programName}}
                    </div>
                  </div>
                  <div class="counts">
                    <div class="col-6 pl-0">
                      <i class="fa fa-line-chart"></i>
                      <span class="pl-2">{{card?.complexityLevel}}</span><br>
                      <i class="fa fa-caret-square-o-right"></i>
                      <span class="pl-2">{{card?.totalCourses}} Courses</span>
                    </div>
                    <vr class="vertical"></vr>
                    <div class="col-6 pr-0">
                      <i class="fa fa-clock-o"></i>
                      <span class="pl-2">{{card?.totalTopicsLength}} total hours</span><br>
                      <i class="fa fa-list-alt"></i>
                      <span class="pl-2">{{card?.totalTopics}} Topics</span>
                    </div>
                  </div>
                </div>
              </div>
              <ng-container *ngIf="(i + 1) % 4 == 0 || i == recommendedPrograms.length - 1">
                <div class="row"></div>
              </ng-container>
            </div>
          </div>
          <div class="view-more pt-2" *ngIf="recommendedPrograms?.length >= 8 && showRecommendedViewMore">
            <span (click)="loadRecommendedPrograms()">View More</span>
          </div>
          <div class="view-more h-100" *ngIf="recommendedPrograms?.length <= 0 && !loading">
            <div class="noDataCard mt-0 align-items-center">
              <div class="noDataCardIn">
                <img src="../../../assets/images/no_data.png" height="120px"><br>
                <span class="mt-3 d-block"> No Programs Found</span>
              </div>
            </div>
          </div>
        </div>
      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          <span>
            Trending{{ showTrendingCount && searchText && (trendingCount > 0) ? '(' + trendingCount + ')' : ''}}</span>
        </ng-template>
        <div class="tab_container">
          <div class="tab-background">
            <div class="card_body" *ngFor="let card of trendingPrograms; index as i">
              <div class="card" (click)="goToProgramDetails(card)">
                <div class="card-image">
                  <img [src]="card.programImage?card.programImage : '../../../../assets/images/employeeCareer/code.jpg'"
                    alt="Program Image">
                  <div class="text-overlay">
                    <span class="inprogress" *ngIf="card.status == 'InProgress' ">In Progress</span>
                    <span class="completed" *ngIf="card.status == 'Completed' ">Completed</span>
                    <span class="notstarted" *ngIf="card.status == 'NotStarted' ">Not Started</span>
                  </div>
                </div>
                <div class="card-content">
                  <div class="card_head_content">
                    <div class="department textalign">
                      <span class="department-name">{{card.departmentPathName}}</span>
                    </div>
                    <div class="card-title textalign" title="{{card.programName}}" matTooltip="{{card.programName}}">
                      {{card.programName}}
                    </div>
                  </div>
                  <div class="counts">
                    <div class="col-6 pl-0">
                      <i class="fa fa-line-chart"></i>
                      <span class="pl-2">{{card?.complexityLevel}}</span><br>
                      <i class="fa fa-caret-square-o-right"></i>
                      <span class="pl-2">{{card?.totalCourses}} Courses</span>
                    </div>
                    <vr class="vertical"></vr>
                    <div class="col-6 pr-0">
                      <i class="fa fa-clock-o"></i>
                      <span class="pl-2">{{card?.totalTopicsLength}} total hours</span><br>
                      <i class="fa fa-list-alt"></i>
                      <span class="pl-2">{{card?.totalTopics}} Topics</span>
                    </div>
                  </div>
                </div>
              </div>
              <ng-container *ngIf="(i + 1) % 4 == 0 || i == trendingPrograms.length - 1">
                <div class="row"></div>
              </ng-container>
            </div>
          </div>
          <div class="view-more pt-2" *ngIf="trendingPrograms?.length >= 8 && showTrendingViewMore &&  !loading">
            <span (click)="loadTrendingPrograms()">View More</span>
          </div>
          <div class="view-more h-100" *ngIf="trendingPrograms?.length <= 0">
            <div class="noDataCard mt-0 align-items-center">
              <div class="noDataCardIn">
                <img src="../../../assets/images/no_data.png" height="120px"><br>
                <span class="mt-3 d-block"> No Programs Found</span>
              </div>
            </div>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>

  </div>
</div>
